import React from "react";
import {
  ManageTradeLayout,
  MultiSelectDropdown,
  FieldDropSide,
  DatePicker,
} from "../../components";
import { Field, Formik } from "formik";
import { Form, Button, Image } from "react-bootstrap";
import {
  manageTradeFormNames,
  formFields,
  toMultiSelectValueById,
  usDateFormat,
} from "../../utils";
import { isEmpty } from "lodash";
const transactionTypes = [
  { label: "Computation Period", value: 1 },
  { label: "Credited This Year", value: 2 },
  { label: "Vesting Override", value: 3 },
  // { label: "Vesting Multiplier", value: 4 },
  { label: "Vesting Percentage", value: 5 },
  //{ label: "VestingPercentageMetDate", value: 6 },
  { label: "Years Of Service", value: 6 },
  { label: "Comments", value: 7 },
];

export const SearchView = (props) => {
  const { onSubmit } = props;
  const formName = manageTradeFormNames.TRANSACTION_VIEW;
  const fields = formFields[formName];
  return (
    <Formik
      initialValues={{}}
      onSubmit={onSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        handleChange,
        setFieldValue,
        setFieldError,
        handleSubmit,
        setValues,
        values,
        ...rest
      }) => {
        const onDaySelected = (fieldName, value) => {
          const dateFormete = usDateFormat(value);
          setFieldValue(fieldName, dateFormete);
        };
        return (
          <Form
            autoComplete="off"
            className="mt-10"
            onSubmit={handleSubmit}
            validated={!isEmpty(rest.errors)}
          >
            <div className="search-fields-trade">
              {/* <Field
                        size="smd"
                        label="Search"
                        name={fields.search}
                        value={fields.search}

                        /> */}
              <Field
                size="smd"
                isRequired
                label="Transaction Type"
                name={fields.transactionType}
                value={toMultiSelectValueById(
                  values[fields.transactionType],
                  transactionTypes
                )}
                options={transactionTypes}
                isMultiSelect
                direction="bottom"
                popupContent={
                  <MultiSelectDropdown
                    label="Fields"
                    name={fields.transactionType}
                    onSelect={(value) =>
                      setFieldValue(fields.transactionType, value)
                    }
                    value={values[fields.transactionType]}
                    options={transactionTypes}
                  />
                }
                component={FieldDropSide}
              />
              <Field
                size="smd"
                isRequired
                label="Trade Status"
                name={fields.tradeStatus}
                value={toMultiSelectValueById(
                  values[fields.tradeStatus],
                  transactionTypes
                )}
                options={transactionTypes}
                isMultiSelect
                direction="bottom"
                popupContent={
                  <MultiSelectDropdown
                    label="Fields"
                    name={fields.tradeStatus}
                    onSelect={(value) =>
                      setFieldValue(fields.tradeStatus, value)
                    }
                    value={values[fields.tradeStatus]}
                    options={transactionTypes}
                  />
                }
                component={FieldDropSide}
              />
              <Field
                size="sm"
                isRequired
                label="Date range"
                name={fields.fromDate}
                value={values[fields.fromDate]}
                isDatePicker
                placeholder="From date"
                direction="bottom"
                onClear={() => onDaySelected(fields.fromDate, "")}
                popupContent={
                  <DatePicker
                    onDayClick={(value) =>
                      onDaySelected(fields.fromDate, value)
                    }
                    value={values[fields.fromDate]}
                  />
                }
                component={FieldDropSide}
              />
              <Field
                size="sm"
                label=""
                text=""
                name={fields.toDate}
                isRequired
                placeholder="To date"
                value={values[fields.toDate]}
                direction="bottom"
                isDatePicker
                onClear={() => {
                  onDaySelected(fields.toDate, "");
                  onDaySelected(fields.fromDate, "");
                }}
                onDefaultClearDisplay={values[fields.fromDate]}
                popupContent={
                  <DatePicker
                    onDayClick={(value) => onDaySelected(fields.toDate, value)}
                    value={values[fields.toDate]}
                  />
                }
                component={FieldDropSide}
              />
              <Button
                className="sort-button"
                style={{
                  lineHeight: "19px",
                  marginTop: "28px",
                }}
                variant="secondary"
                type="submit"
              >
                Search
              </Button>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};
